import { v4 as uuidv4 } from 'uuid';
import { useAppStore } from '../common/store';
import { DocgenClient } from '../data/docgenClient';
import { DocumentTemplate } from '../data/interfaces/DocumentTemplate';
import {
	OpenInDesktopServiceProps,
	SpawnMicrosoftOfficeWithWopi,
} from './OpenInDesktopService';
interface WOPIResponse {
	editUrl: string;
}

const addinId = 'wa200008594';
export const hostInstallAddins = [{ addinId, type: 'TaskPaneApp' }];
export const openWOPILink = async (documentTemplate: DocumentTemplate) => {
	const response: WOPIResponse = await DocgenClient.getEditUrlForRID(
		documentTemplate.rid
	);

	const editUrl = response.editUrl;

	const guid = uuidv4();

	// Pass Add-in ID to the browser session storage and it will appended to edit URL in File Viewer pilet to open pre-installed add-in in the Iframe.
	// Iframe is rendered by File-Viewer pilet after the redirecting to url path /file/edit/{guid}.
	const data = {
		filename: documentTemplate.file.fileName,
		rid: documentTemplate.file.fileRID,
		editurl: editUrl,
		fileViewerConfig: {
			hostInstallAddins: encodeURIComponent(JSON.stringify(hostInstallAddins)),
		},
	};
	const FILE_EDIT_PATH = '/file/edit';
	sessionStorage.setItem(guid, JSON.stringify(data));
	window.open(`${FILE_EDIT_PATH}/${guid}`, '_blank');
	return response;
};

export const openDesktopApplication = async () => {
	const { documentTemplate, user } = useAppStore.getState();
	const response: WOPIResponse = await DocgenClient.getEditUrlForRID(
		documentTemplate.rid
	);

	const editUrl = response.editUrl;

	const urlParams = new URLSearchParams(editUrl?.split('?')[1]);
	const wopiSrc = urlParams.get('WOPISrc') ?? '';
	const desktopProps: OpenInDesktopServiceProps = {
		userId: user.Id,
		wopiUrl: wopiSrc,
		fileName: documentTemplate.file.fileName,
	};
	SpawnMicrosoftOfficeWithWopi(desktopProps);
};
